export enum LoadersEnum {
  ACTIVATE = "activate",
  CC = "cost-centers",
  CUSTOMER = "customer",
  HISTORY = "history",
  HOME_USAGE = "home_usage",
  LANGUAGE = "language",
  LINK = "link",
  NOTIFICATION = "notification",
  NOTIF_HIST = "notification_history",
  ORDER = "order",
  PRIVACY = "privacy",
  PRODUCT = "product",
  PROMOTION = "promotion",
  SAFEGUARD = "safeguard",
  SETTINGS = "b_settings",
  SITUATION = "bill_situation",
  SUPPORT = "support"
}
